// We want our initial chunk to be as small as possible so that we download it quickly and show a loading screen immediately
// Imports here should be carefully considered such that they don't significantly increase the initial download size
import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import LoadingScreen from "./areas/infrastructure/components/LoadingScreen/LoadingScreen";
import type { LoadingError } from "./components/LoadingScreen/LoadingScreenNew";
import { LoadingScreenNew } from "./components/LoadingScreen/LoadingScreenNew";
import { isNewLoadingAnimationEnabled } from "./components/LoadingScreen/isNewLoadingAnimationEnabled";
import { setupInitialTheme } from "./components/LoadingScreen/setupInitialTheme";

const App = React.lazy(() => import("./App"));

setupInitialTheme();

function render(Component: typeof AppWithLoading) {
    const container = document.getElementById("app");
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const root = createRoot(container!);
    root.render(<Component />);
}

function AppWithLoading() {
    const [isReady, setIsReady] = useState(false);
    const [loadingError, setLoadingError] = useState<LoadingError>();

    return (
        <>
            <React.Suspense fallback={isNewLoadingAnimationEnabled ? null : <LoadingScreen inProgressMessage="Loading, please wait..." errorDetails={null} />}>
                <App onReady={() => setIsReady(true)} onInitialLoadError={setLoadingError} />
            </React.Suspense>
            {!isReady && isNewLoadingAnimationEnabled && <LoadingScreenNew error={loadingError} />}
        </>
    );
}

render(AppWithLoading);
